
import { ProductCSVImportProductMatchingMethod } from "@/services/product-service";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		value: String as ()=>ProductCSVImportProductMatchingMethod
	},
	computed: {
		productMatchingMethods():ISelectItem<ProductCSVImportProductMatchingMethod>[] {
			return getEnumKeys(ProductCSVImportProductMatchingMethod).map(k=>{
				return {
					text: this.$ct(`components.products.csv-import-product-matching-method.${k}`),
					value: getEnumValueFromKey(ProductCSVImportProductMatchingMethod, k)
				}as ISelectItem<ProductCSVImportProductMatchingMethod>;
			});
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				let methods = this.productMatchingMethods.map(m=>m.value);
				if (methods.indexOf(this.value) == -1) {
					this.$emit("input", methods[0]);
				}
			}
		}
	}
});
